// ItemCardButton.tsx
import React from "react";
import {
  MdAddShoppingCart,
  MdPlaylistAdd,
  MdDelete,
  MdRemove,
  MdAdd,
  MdCheck,
} from "react-icons/md";
import styles from "./ItemCardButton.module.scss";
import { useTheme } from "../../hooks/useTheme";

interface ItemCardButtonProps {
  quantity: number;
  showCartButton: boolean;
  showComplexButton: boolean;
  isComplexCategory: boolean;
  isOutOfStock: boolean;
  isIncreaseDisabled: boolean;
  hasPrice: boolean;
  isInComplexCart?: boolean;
  onAddToCart: (e: React.MouseEvent) => void;
  onAddToComplex: (e: React.MouseEvent) => void;
  onIncrease: (e: React.MouseEvent) => void;
  onDecrease: (e: React.MouseEvent) => void;
  onRemove: (e: React.MouseEvent) => void;
}

export const ItemCardButton: React.FC<ItemCardButtonProps> = ({
  quantity,
  showCartButton,
  showComplexButton,
  isComplexCategory,
  isOutOfStock,
  isIncreaseDisabled,
  hasPrice,
  isInComplexCart = false,
  onAddToCart,
  onAddToComplex,
  onIncrease,
  onDecrease,
  onRemove,
}) => {
  const { theme } = useTheme();

  const handleClick =
    (handler: (e: React.MouseEvent) => void) => (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      handler(e);
    };

  if (quantity > 0) {
    return (
      <div className={styles.quantityContainer}>
        <button
          className={styles.quantityButton}
          onClick={handleClick(quantity === 1 ? onRemove : onDecrease)}
        >
          {quantity === 1 ? (
            <MdDelete size={16} color={theme.danger} />
          ) : (
            <MdRemove size={16} color={theme.primary} />
          )}
        </button>
        <div className={styles.quantityDisplay}>
          <span className={styles.quantityText}>{quantity}</span>
          <span className={styles.quantityLabel}>шт.</span>
        </div>
        <button
          className={`${styles.quantityButton} ${isIncreaseDisabled ? styles.disabledButton : ""}`}
          onClick={handleClick(onIncrease)}
          disabled={isIncreaseDisabled}
        >
          <MdAdd
            size={16}
            color={isIncreaseDisabled ? theme.textSecondary : theme.success}
          />
        </button>
      </div>
    );
  }

  // Одна большая кнопка "В проект"
  if (showComplexButton && !showCartButton) {
    return (
      <button
        className={styles.cartButton}
        onClick={handleClick(onAddToComplex)}
      >
        <MdPlaylistAdd size={16} color="#fff" />
        <span className={styles.buttonText}>В проект</span>
      </button>
    );
  }

  // "В корзину" + маленькая "В проект"
  if (showComplexButton && showCartButton) {
    return (
      <div className={styles.buttonsRow}>
        <button
          className={`${styles.cartButton} ${!hasPrice || isOutOfStock ? styles.disabled : ""}`}
          onClick={handleClick(onAddToCart)}
          disabled={!hasPrice || isOutOfStock}
        >
          <MdAddShoppingCart size={16} color="#fff" />
          <span className={styles.buttonText}>В корзину</span>
        </button>
        <button
          className={styles.complexButton}
          onClick={handleClick(onAddToComplex)}
        >
          {isInComplexCart ? (
            <MdCheck size={16} color="var(--primary)" />
          ) : (
            <MdPlaylistAdd size={16} color="var(--primary)" />
          )}
        </button>
      </div>
    );
  }

  // Только "В корзину"
  return (
    <button
      className={`${styles.cartButton} ${!hasPrice || isOutOfStock ? styles.disabled : ""}`}
      onClick={handleClick(onAddToCart)}
      disabled={!hasPrice || isOutOfStock}
    >
      <MdAddShoppingCart size={16} color="#fff" />
      <span className={styles.buttonText}>В корзину</span>
    </button>
  );
};